export const LENDER_FUNDED_STATUSES: string[] = [
  'LENDER_FUNDED',
  'LENDER_FUNDED_PENDING',
  'AUTOPAY_FUNDED',
  'TITLE_QA',
  'PAYOFF_SENT',
  'PERFECTING_TITLE_AUTOPAY',
  'PERFECTING_TITLE_DEALER',
];
